import script from "./UpdatePointing.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdatePointing.vue?vue&type=script&lang=ts&setup=true"

import "./UpdatePointing.vue?vue&type=style&index=0&id=e15bfd70&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e15bfd70"]])

export default __exports__